<template>
  <div id="projects-page">
    <ParallaxHeader :headline="'Projects'" :slogan="''"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <!-- <v-flex xs12 lg10 xl8> -->
        <v-flex xs12 lg8 xl6>
          <v-tabs color="grey lighten-2" left>
            <v-tab v-for="tab in tabs" :key="tab.name" @click="showTab(tab.tab)">
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <Projects v-if="tabAll" :cards="projects"/>
          <CompletedDevelopments v-else/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Projects from '@/components/ProjectsList'
import CompletedDevelopments from '@/components/CompletedDevelopment'
import ParallaxHeader from '@/components/ParallaxHeader'
import Api from '@/api'

export default {
  data () {
    return {
      tabAll: true,
      tabCompleted: false,
      tabs: [
        {name: 'All', tab: 'tab-all'}
        // {name: 'Completed Developments', tab: 'tab-completed'}
      ],
      projects: []
      // projectDetails: []
    }
  },
  components: {
    Projects,
    CompletedDevelopments,
    ParallaxHeader
  },
  beforeMount () {
    this.getProjectsData()
  },
  methods: {
    showTab (tabName) {
      if (tabName === 'tab-all') {
        this.tabAll = true
        this.tabCompleted = false
      } else if (tabName === 'tab-completed') {
        this.tabAll = false
        this.tabCompleted = true
      }
    },
    getProjectsData () {
      const path = '/project'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.projects = response.data.project
            // this.projectDetails = response.data.project_details
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
#projects-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.container {
  /*min-height: 58vh;*/
}
.tabs {
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/ProjectsPage.vue